
export const sFechaPublicacion = '2026-02-27T10:26:38.7983452-06:00';
export const sVersion = 'vf1.1.602271026';
            